import { Component, HostListener, Input, OnInit } from "@angular/core";
import { CoreConfigService } from "../../../../@core/services/config.service";
import { Breadcrumb } from "./breadcrumb/breadcrumb.component";

// ContentHeader component interface
export interface ContentHeader {
  headerTitle: string;
  actionButton: boolean;
  breadcrumb?: Breadcrumb;
  translate?: string;
}

@Component({
    selector: "app-content-header",
    templateUrl: "./content-header.component.html",
    standalone: false
})
export class ContentHeaderComponent implements OnInit {
  // input variable
  @Input() contentHeader: ContentHeader;
  isFullscreen: boolean = false;

  constructor(private coreConfigService: CoreConfigService) {}

  ngOnInit() {}

  toggleFullscreen() {
    if (this.isFullscreen) {
      this.exitFullscreen();
    } else {
      this.enterFullscreen();
    }
  }

  enterFullscreen() {
    this.coreConfigService.setConfig({
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        enableLocalStorage: false,
      },
    });
    var elem = document.documentElement as any;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
    this.isFullscreen = true;
    document.body.classList.add("fullscreen");
  }

  exitFullscreen() {
    const doc = document as any;
    if (doc.exitFullscreen) {
      doc.exitFullscreen();
    } else if (doc.mozCancelFullScreen) {
      /* Firefox */
      doc.mozCancelFullScreen();
    } else if (doc.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      doc.webkitExitFullscreen();
    } else if (doc.msExitFullscreen) {
      /* IE/Edge */
      doc.msExitFullscreen();
    }
  }

  @HostListener("document:fullscreenchange", ["$event"])
  @HostListener("document:webkitfullscreenchange", ["$event"])
  @HostListener("document:mozfullscreenchange", ["$event"])
  @HostListener("document:MSFullscreenChange", ["$event"])
  onExitFullscreen(event: any) {
    const doc = document as any;
    if (!doc.webkitIsFullScreen && !doc.mozFullScreen && !doc.msFullscreenElement) {
      this.coreConfigService.setConfig({
        layout: {
          navbar: {
            hidden: false,
          },
          menu: {
            hidden: false,
          },
          footer: {
            hidden: false,
          },
          enableLocalStorage: true,
        },
      });

      this.isFullscreen = false;
      document.body.classList.remove("fullscreen");
    }
  }
}
